<template>
  <div class="topbar">
    <div class="right-menu">
      <template v-if="!isMobileDevice && !isProduction">
        <ErrorLog class="errLog-container right-menu-item hover-effect" />
      </template>
      <!-- TODO: Disable the Global search. Wait for BE fixes the bug from BE side -->
      <!-- <div
        v-if="!isOnboardingFlow"
        id="search-input-container"
        class="search-input-container"
        @click="handleShowSearchBox"
      >
        <span class="svg-container">
          <svg-icon icon-class="search-gray" />
        </span>
        <el-input
          :placeholder="$t('topbar_search_placeholder')"
          class="search-input"
        />
      </div> -->
      <div
        v-if="showSearchBox"
        :class="
          `${
            isCollapse
              ? 'topbar__search-box topbar__search-box--collapsed'
              : 'topbar__search-box'
          }`
        "
      >
        <div ref="searchBox" class="topbar__search-box-container">
          <div id="search-box-input-container" class="search-input-container">
            <span class="svg-container">
              <svg-icon icon-class="search-gray" />
            </span>
            <el-input
              v-model="search"
              :placeholder="$t('topbar_search_placeholder')"
              class="search-input"
              @change="onSearchTextChange"
            />
            <span
              :class="search ? 'topbar__clear' : 'topbar__clear--hidden'"
              @click="handleClickClear"
            >
              {{ $t('topbar_clear') }}
            </span>
            <span class="svg-container svg-suffix-close">
              <svg-icon icon-class="close" @click="handleClickClose" />
            </span>
          </div>
          <el-tabs v-model="resultType" class="topbar__tabs">
            <el-tab-pane
              :label="
                $t('topbar_tab_order', { count: globalSearchOrdersCount })
              "
              name="Orders"
            />
          </el-tabs>
          <template v-if="fetchingList">
            <div class="topbar__search-result-title">
              {{ $t('header_orders') }}
            </div>
            <div
              v-for="item in [0, 1, 2]"
              :key="item"
              class="topbar__search-items topbar__search-items-skeleton"
            >
              <div>
                <div class="topbar__result-title">
                  <VueSkeletonLoader
                    type="rect"
                    :width="320"
                    :height="12"
                    animation="wave"
                    color="#F2F2F2"
                  />
                </div>
                <div class="topbar__search-items-secondary">
                  <VueSkeletonLoader
                    type="rect"
                    :width="100"
                    :height="12"
                    color="#F2F2F2"
                    animation="wave"
                  />
                </div>
              </div>
              <div>
                <VueSkeletonLoader
                  type="rect"
                  :width="83"
                  :height="26"
                  color="#F2F2F2"
                  animation="wave"
                />
              </div>
            </div>
          </template>
          <template v-else>
            <template v-if="globalSearchOrders.length">
              <div class="topbar__search-result-title">
                {{ $t('header_orders') }}
              </div>
              <div
                v-for="item in globalSearchOrders"
                :key="item.orderId"
                class="topbar__search-items"
                @click="handleClickOrder(item)"
              >
                <div>
                  <div class="topbar__result-title">
                    {{ item.consumer.fullName }}
                  </div>
                  <div class="topbar__search-items-secondary">
                    <span class="topbar__search-items-secondary--small">
                      {{ item.currency }}
                    </span>
                    {{ getFormattedAmount(item.totalAmount, item.currency) }}
                  </div>
                </div>
                <div class="topbar__order-type">
                  <svg-icon icon-class="split" />
                  {{
                    item.paymentType
                      | paymentTypeFormatter
                      | translatePaymentType()
                  }}
                </div>
              </div>

              <div class="topbar__view-all" @click="goToOrderPage">
                {{
                  $t('topbar_view_all', {
                    count: globalSearchOrdersCount,
                  })
                }}
              </div>
            </template>

            <template
              v-else-if="search && startSearching && !globalSearchOrders.length"
            >
              <div class="topbar__empty-search">
                <svg-icon icon-class="search-purple" />
                <div>
                  {{ $t('topbar_no_result') }}
                </div>
              </div>
            </template>

            <template v-else>
              <div class="topbar__empty-search">
                <svg-icon icon-class="search-purple" />
                <div>
                  {{ $t('topbar_find_anything') }}
                </div>
              </div>
            </template>
          </template>
        </div>
      </div>
      <div class="topbar__navigation">
        <el-link
          :class="`navbar-lang ${isArabic ? '' : 'navbar-lang--ar'}`"
          type="text"
          @click="handleSwitchLocale"
        >
          {{ $t('text_locale_switch_link') }}
        </el-link>
        <div v-if="userCanViewDisputes" class="topbar__notifications">
          <el-dropdown
            ref="notificationsDropdown"
            trigger="click"
            @visible-sync="notificationsDropdownVisible"
          >
            <div
              class="topbar__notifications-icon"
              :class="
                notificationsDropdownVisible
                  ? 'topbar__notifications-icon--active'
                  : ''
              "
            >
              <svg-icon
                v-if="notificationsDropdownVisible"
                icon-class="notification-gray"
              />
              <svg-icon
                v-if="!notificationsDropdownVisible"
                icon-class="notification-gray"
              />
              <div
                v-if="!notificationsDropdownVisible"
                class="topbar__notifications-number"
              />
            </div>

            <el-dropdown-menu
              slot="dropdown"
              class="topbar__notifications-dropdown"
            >
              <div v-if="latestDisputeList && latestDisputeList.length > 0">
                <el-dropdown-item
                  v-for="(item, index) in latestDisputeList"
                  :key="index"
                >
                  <div
                    class="topbar__notifications-item"
                    @click="goToDisputeDetail(item)"
                  >
                    <div class="topbar__notifications-item-content">
                      <div class="topbar__notifications-item-title">
                        {{ $t('dispute_notification_text1') }} #{{
                          item.disputeId
                        }}
                        {{ $t('dispute_notification_text2') }}
                      </div>
                      <div
                        class="topbar__notifications-item-respond"
                        @click="goToDisputesActionRequiredPage"
                      >
                        {{ $t('dispute_respond_now') }}
                      </div>
                    </div>
                  </div>
                  <div class="topbar__notifications-item-divider" />
                </el-dropdown-item>
                <el-dropdown-item class="topbar__notifications-see-all">
                  <div @click="goToDisputesActionRequiredPage">
                    {{ $t('dispute_see_all') }}
                  </div>
                </el-dropdown-item>
              </div>
              <el-dropdown-item v-else :disabled="true">
                <div
                  class="topbar__notifications-item topbar__notifications-item--empty"
                >
                  <div>
                    <svg-icon icon-class="notifications-empty" />
                  </div>
                  <div>
                    {{ $t('dispute_no_new_notifications_title') }}
                  </div>
                  <div>
                    {{ $t('dispute_no_new_notifications_description') }}
                  </div>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>

        <div class="divider" />
        <el-dropdown
          class="avatar-container right-menu-item hover-effect"
          trigger="click"
          :hide-on-click="false"
          @visible-change="handleDropdownVisibleChange"
        >
          <div class="flex flex-row items-center">
            <div
              :class="
                `${
                  isDropdownVisible
                    ? 'items-center email-bar email-bar-visible'
                    : 'items-center email-bar'
                }`
              "
            >
              <span v-if="!isMobileDevice" class="mx-2">
                {{ userNameLabel }}
              </span>
            </div>
          </div>

          <el-dropdown-menu slot="dropdown" class="topbar__actions-popup">
            <el-dropdown-item
              v-if="isMobileDevice"
              class="topbar__actions-item"
              disabled
            >
              {{ userProfile.email }}
            </el-dropdown-item>
            <el-dropdown-item
              class="topbar__actions-item topbar__actions-item--header"
              disabled
            >
              <div>
                {{ $t('account_text') }}
              </div>
              {{ `${userProfile.firstName} ${userProfile.lastName}` }}
            </el-dropdown-item>
            <div class="topbar__divider" />
            <el-dropdown-item
              v-if="!isOnboardingFlow"
              class="topbar__actions-item"
              @click.native="viewProfile"
            >
              <svg-icon icon-class="user-setting" />

              {{ $t('profile_dropdown') }}
            </el-dropdown-item>

            <el-dropdown-item
              v-if="!isOnboardingFlow"
              class="topbar__actions-item"
              @click.native="viewSupport"
            >
              <svg-icon icon-class="support-gray" />

              {{ $t('topbar_support_text') }}
            </el-dropdown-item>

            <el-dropdown-item
              class="topbar__actions-item"
              @click.native="viewHelpDesk"
            >
              <svg-icon icon-class="help-question" />

              {{ $t('topbar_help_text') }}
            </el-dropdown-item>
            <el-dropdown-item
              class="topbar__actions-item topbar__actions-item--delete"
              @click.native="logout"
            >
              {{ $t('header_logout') }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-tooltip
          v-if="!isOnboardingFlow"
          placement="bottom"
          :open-delay="200"
          :disabled="userCanViewCreateOrder"
          :content="tooltipContent"
        >
          <el-button
            id="create-order-button"
            class="global__button-black topbar__button"
            :disabled="!userCanViewCreateOrder"
            @click="handleClickCreateOrder"
          >
            <svg-icon icon-class="add-circle-white" />
            {{ $t('topbar_create_order') }}
          </el-button>
        </el-tooltip>
        <CreateOrderDrawer
          :visible="showCreateOrder"
          :close="closeCreateOrder"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import VueSkeletonLoader from 'skeleton-loader-vue'
import { amountFormatter } from '@/filters'
import logoImage from '@/assets/images/sidebar-logo.svg'
import logoImageAr from '@/assets/images/sidebar-logo-ar.svg'
import ErrorLog from '@/components/ErrorLog'
import { capitalizeFirstLetter } from '@/utils'
import { OPEN_STATUS } from '@/views/dispute/constants/status-options'
import userHasPermission from '@/utils/user-has-permission'
import CreateOrderDrawer from '@/components/CreateOrderDrawer'

export default {
  components: {
    VueSkeletonLoader,
    ErrorLog,
    CreateOrderDrawer,
  },
  props: {
    isCollapse: {
      type: Boolean,
      default: false,
    },
    isOnboardingFlow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      logoImage,
      logoImageAr,
      capitalizeFirstLetter,
      notificationsDropdownVisible: false,
      showSearchBox: false,
      search: '',
      resultType: 'All',
      isDropdownVisible: false,
      startSearching: false,
      showCreateOrder: false,
      currentSearchText: {
        key: 'searchText',
        identifier: 'like',
        value: '',
      },
    }
  },
  computed: {
    ...mapGetters(['sidebar', 'avatar', 'device']),
    ...mapGetters('profile', { merchantProfile: 'profile' }),
    ...mapGetters('translations', ['currentLocale', 'isArabic']),
    ...mapGetters('profile', ['profile']),
    ...mapGetters('userProfile', { userProfile: 'profile' }),
    ...mapState('dispute', ['actionRequiredCount']),
    ...mapState('globalSearch', [
      'globalSearchOrders',
      'globalSearchOrdersCount',
      'fetchingList',
    ]),
    ...mapGetters('dispute', {
      actionRequiredDisputesList: 'getActionRequiredList',
    }),
    tooltipContent() {
      if (
        !this.profile.inStoreQrCodeSolutionEnabled &&
        !this.profile.inStorePaymentLinkEnabled
      ) {
        return this.$t('create_order_button_tooltip_cannot_view')
      }
      if (!this.userCanCreateInStoreOrder) {
        return this.$t('create_order_button_tooltip_not_allow')
      }
      return ''
    },
    isSearching() {
      return this.search !== ''
    },
    userCanViewCreateOrder() {
      return (
        this.userCanCreateInStoreOrder &&
        (this.profile.inStoreQrCodeSolutionEnabled ||
          this.profile.inStorePaymentLinkEnabled)
      )
    },
    userCanCreateInStoreOrder() {
      return (
        this.profile &&
        this.profile.inStore &&
        userHasPermission(['order_create'])
      )
    },
    userNameLabel() {
      return `${this?.userProfile?.firstName
        ?.slice(0, 1)
        .toUpperCase()}${this?.userProfile?.lastName
        ?.slice(0, 1)
        .toUpperCase()}`
    },
    userCanViewDisputes() {
      return this.merchantProfile && userHasPermission(['get_dispute_listing'])
    },
    latestDisputeList() {
      // return only latest 3 for notifications dropdown
      return this.actionRequiredDisputesList
        ? this.actionRequiredDisputesList?.slice(0, 3)
        : null
    },
    serviceStatusUrl() {
      return `${this.$t('service_status_url')}`
    },
    supportUrl() {
      const queries = []

      if (this.merchantProfile.merchantId) {
        queries.push(`merchant_id=${this.merchantProfile.merchantId}`)
      }

      const queryString = queries.join('&')

      return `${this.$t(
        'zendesk_helper_url_without_hash'
      )}?${queryString}#merchants`
    },
    isMobileDevice() {
      return this.device === 'mobile'
    },
    isProduction() {
      return process.env.VUE_APP_ENV === 'production'
    },
    merchantName() {
      const arMerchantName =
        this.profile.arMerchantName || this.profile.merchantName
      const merchantName =
        this.profile.merchantName || this.profile.arMerchantName

      return (
        {
          ar_SA: arMerchantName,
          en_US: merchantName,
        }[this.currentLocale] || 'N/A'
      )
    },
  },
  beforeDestroy() {
    this.removeClickOutsideListener()
  },
  methods: {
    ...mapActions('globalSearch', ['searchGlobal', 'clearSearchResult']),
    handleClickClose() {
      this.handleHideSearchBox()
    },
    handleClickClear() {
      this.clearSearch()
    },
    closeCreateOrder() {
      this.showCreateOrder = false
    },
    handleClickCreateOrder() {
      this.showCreateOrder = true

      this.$track.event('header_create_order_clicked')
    },
    getFormattedAmount(amount, currency) {
      return amountFormatter({ amount, currency })
    },
    handleClickOrder(item) {
      this.handleHideSearchBox()
      this.$router.push({
        path: `/order/detail/${item.orderId}?merchantId=${item.merchantId}`,
      })
    },

    onSearchTextChange() {
      if (!this.search || typeof this.search !== 'string') {
        this.startSearching = false
        this.clearSearchResult()
        return
      }
      this.search = this.search.trim()
      this.searchGlobal(this.search)
      this.startSearching = true
    },
    handleDropdownVisibleChange(val) {
      this.isDropdownVisible = val
      // trigger click on collapse language title to collapse if the collapse is expanded and user close the logo dropdown
      const isExpanded =
        document.getElementsByClassName('el-collapse-item__wrap')[0] &&
        document.getElementsByClassName('el-collapse-item__wrap')[0].style
          .display !== 'none'
      if (!val && isExpanded) {
        document.getElementsByClassName('topbar_collapse--title')[0].click()
      }
      // click on collapse item title to collapse
    },

    handleCloseDropdown() {
      document.getElementsByClassName('el-dropdown-selfdefine')[1].click()
    },
    clearSearch() {
      this.search = ''
      this.clearSearchResult()
      this.startSearching = false
    },
    handleClickOutside(event) {
      if (!this.$refs.searchBox?.contains(event.target)) {
        this.handleHideSearchBox()
      }
    },
    addClickOutsideListener() {
      document.addEventListener('click', this.handleClickOutside)
    },
    removeClickOutsideListener() {
      document.removeEventListener('click', this.handleClickOutside)
    },
    handleShowSearchBox() {
      this.showSearchBox = true
      this.disablePageScroll()
      this.clearSearch()

      this.$nextTick(() => {
        setTimeout(() => {
          this.addClickOutsideListener()
        }, 0)
      })
    },
    handleHideSearchBox() {
      this.showSearchBox = false
      this.enablePageScroll()

      this.clearSearch()
      this.removeClickOutsideListener()
    },
    goToDisputeDetail(item) {
      this.$router.push({
        path: `/dispute/detail/${item.disputeId}?merchantId=${item.merchantId}`,
      })
    },
    disablePageScroll() {
      document.body.style.overflow = 'hidden'
    },
    enablePageScroll() {
      document.body.style.overflow = ''
    },
    goToDisputesActionRequiredPage() {
      this.$router.push({
        name: 'dispute-list-action-required',
        query: {
          statuses: OPEN_STATUS,
          statusPage: 'action-required',
        },
      })
    },
    goToOrderPage() {
      this.$router.push({
        path: `/order/list?merchantIds=${this.merchantProfile.merchantId}&searchText%5Blike%5D=${this.search}`,
      })
      this.handleHideSearchBox()
    },
    // /order/list?timezone=Asia%2FRiyadh&merchantIds=c9ed27c2-1529-4fb6-a68e-f837f212e81f&page=1&searchText%5Blike%5D=a
    handleSwitchLocale() {
      const nextLocale = this.currentLocale === 'en_US' ? 'ar_SA' : 'en_US'
      const query = { ...this.$route.query, locale: nextLocale }
      this.$router.push(
        {
          path: this.$route.path,
          query: query,
        },
        () => {
          window.location.reload()
        }
      )
    },
    viewProfile() {
      this.handleCloseDropdown()
      this.$router.push('/profile')
    },
    viewSupport() {
      this.handleCloseDropdown()
      window.open(this.serviceStatusUrl)
    },
    viewHelpDesk() {
      window.open(this.supportUrl)
    },

    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/_breakpoints';

$search-container-margin: 274px;
$search-container-margin--collapsed: 119px;
$input-bg: #f9f8fa;
$text-secondary-color: #999;

.search-global-function .animation--wave {
  border-radius: 6px !important;
}

.email-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  font-family: 'Space Grotesk', sans-serif;
  font-size: 13px;
  font-weight: 600;
  line-height: 20px;
  color: #8267db;
  text-align: left;
  background: #f0e8ff;
  border-radius: 48px;
}

.email-bar-visible {
  border: 1.5px solid #ab8dff;
}

.logo-container {
  display: flex;
  align-items: center;
}

.sidebar-logo {
  filter: brightness(0) saturate(100%) invert(100%) sepia(100%) saturate(0%)
    hue-rotate(104deg) brightness(103%) contrast(103%);
}

.topbar__search-box {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  width: 100%;
  height: 100%;
  padding: 20px;
  overflow: hidden;
  background: #0003;
}

.topbar__search-box-container {
  position: absolute;
  top: 16px;

  [dir='ltr'] & {
    left: $search-container-margin;
  }

  [dir='rtl'] & {
    right: $search-container-margin;
  }

  z-index: 10000;
  width: 520px;
  height: auto;
  padding: 20px;
  background: white;
  border: 1px solid #e5e5e5;
  border-radius: 16px;
}

.topbar__search-box--collapsed .topbar__search-box-container {
  [dir='ltr'] & {
    left: $search-container-margin--collapsed;
  }

  [dir='rtl'] & {
    right: $search-container-margin--collapsed;
  }
}

.topbar__search-box ::v-deep .el-input__suffix {
  display: block !important;
}

.topbar__button {
  border-radius: 48px;
}

.topbar__button ::v-deep span {
  display: flex;
  gap: 10px;
  align-items: center;
}

.topbar__button ::v-deep span svg {
  width: 18px;
  height: 18px;
}

.search-input-container {
  display: flex;
  align-items: center;
  justify-items: center;
  width: 100%;
  max-width: 488px;
  height: 49px;
  color: $text-secondary-color;
  background: $input-bg;
  border-radius: 24px;
}

.search-input-container ::v-deep input {
  height: initial;
  padding: 0;
  margin: 0;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 14.4px;
  color: $text-secondary-color;
  text-align: left;
  background: $input-bg;
  border: none;

  &::placeholder {
    color: #999;
  }
}

.topbar_collapse {
  width: 100%;
  border: none;

  .el-collapse-item {
    width: 100%;
  }
}

.topbar_collapse ::v-deep .el-collapse-item__header {
  display: flex;
  align-items: center;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  background: transparent;
  border: none;

  svg {
    [dir='ltr'] & {
      margin-right: 10px;
    }

    [dir='rtl'] & {
      margin-left: 10px;
    }
  }
}

.topbar_collapse ::v-deep .el-collapse-item__wrap {
  padding-left: 30px;
  background: transparent;
  border: none;

  .el-collapse-item__content {
    padding-bottom: 5px;
  }

  .el-collapse-item__content div {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
  }

  .el-collapse-item__content div span {
    margin-right: 4px;
    margin-bottom: 13px;
    font-size: 25px;
    line-height: 0;
  }
}

.topbar_collapse ::v-deep .el-collapse-item__content div:hover {
  font-weight: 600;
}

.topbar_collapse ::v-deep .el-collapse-item__arrow {
  transform: rotate(90deg);
}

.topbar_collapse ::v-deep .el-collapse-item__arrow.is-active {
  transform: rotate(270deg);
}

.search-input-container ::v-deep .svg-icon {
  width: 18.22px;
  height: 18.22px;
}

.search-input-container ::v-deep .el-input__suffix {
  top: -8px !important;
}

.search-input-container ::v-deep .el-input__inner {
  [dir='rtl'] & {
    text-align: right;
  }
}

.search-input-container ::v-deep .svg-container {
  display: inline-block;
  margin-right: 10px;
  margin-left: 5px;
  color: #000;
  vertical-align: middle;

  [dir='ltr'] & {
    padding: 6px 5px 6px 12px;
  }

  [dir='rtl'] & {
    padding: 6px 12px 6px 5px;
  }
}

.search-input-container ::v-deep .svg-container.svg-suffix {
  display: flex;
  flex-shrink: 0;
  gap: 5px;
  align-items: center;
  width: 90px;
  padding: 0;

  [dir='ltr'] & {
    margin: 0 20px 0 0;
  }

  [dir='rtl'] & {
    margin: 0 0 0 20px;
  }

  font-family: 'Inter', sans-serif;
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  color: #ccc;
  text-align: left;

  svg {
    width: 22px;
    height: 25px;
  }
}

.search-input-container ::v-deep .svg-container.svg-suffix-close {
  padding: 0;

  [dir='ltr'] & {
    margin: 0 20px 0 0;
  }

  [dir='rtl'] & {
    margin: 0 0 0 20px;
  }

  svg {
    width: 12px;
    height: 12px;
    cursor: pointer;
  }

  &.hidden {
    opacity: 0;

    svg {
      cursor: auto;
    }
  }
}

.search-input-container ::v-deep .topbar__clear {
  margin-inline-end: 10px;
  font-size: 14px;
  color: #8267db;
  cursor: pointer;
}

.search-input-container ::v-deep .topbar__clear--hidden {
  visibility: hidden;
}

.topbar__search-box .search-input-container {
  color: black;
  background: white;
  border: 1px solid #666;
  border-radius: 12px;
}

.topbar__search-box .search-input-container ::v-deep input {
  font-size: 14px;
  font-weight: 400;
  color: black;
  background: white;

  &::placeholder {
    color: #999;
  }
}

.topbar__tabs ::v-deep .el-tabs__nav {
  margin-top: 15px;

  [dir='ltr'] & {
    float: left;
  }

  [dir='rtl'] & {
    float: right;
  }
}

.topbar__tabs ::v-deep .el-tabs__active-bar {
  background: #8267db;
}

.topbar__tabs ::v-deep .el-tabs__item.is-active {
  font-weight: 600;
  color: #8267db;
}

.topbar__tabs ::v-deep .el-tabs__item {
  width: 100px;
  padding: 0 !important;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #999;
}

.topbar .topbar__search-items {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  max-height: 66px;
  padding: 5px 0;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 25px;
  text-align: left;
  border-radius: 8px;

  .topbar__result-title {
    display: inline-block;
    max-width: 320px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &:hover {
    width: calc(100% + 20px);
    max-height: 66px;
    padding: 5px 10px;
    margin-left: -10px;
    cursor: pointer;
    background: #f2f2f2;

    .topbar__result-title {
      font-weight: 500;
    }
  }

  &.topbar__search-items-skeleton:hover {
    background: none;

    .topbar__result-title {
      font-weight: 400;
    }
  }

  .topbar__search-items-secondary {
    font-family: 'Helvetica Neue', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #999;

    .topbar__search-items-secondary--small {
      font-size: 12px;
    }
  }
}

.topbar .topbar__order-type {
  display: flex;
  gap: 5px;
  align-items: center;
  padding: 2px 8px;
  font-family: 'Helvetica Neue', sans-serif;
  font-size: 12px;
  font-weight: 400;
  color: #666;
  background: #0000000d;
  border-radius: 48px;
}

.topbar .topbar__view-all {
  margin: 10px 0;
  font-size: 14px;
  font-weight: 400;
  color: #8267db;
  cursor: pointer;
}

.topbar__tabs ::v-deep .el-tabs__item:hover {
  color: #8267db;
}

.navbar-help,
.navbar-lang {
  margin: 0 16px;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  color: #999;
}

.navbar-help svg {
  width: 26px;
  height: 26px;
}

.navbar-lang.navbar-lang--ar {
  font-family: 'IBM Plex Sans Arabic', sans-serif;
}

.divider {
  width: 1px;
  height: 30px;
  margin: 0 12px;
  background: #ededed;
}

.navbar-help ::v-deep .el-link--inner {
  display: flex;
  align-items: center;

  > div {
    margin: 0 3px;
  }
}

.el-link.is-underline:hover::after {
  display: none;
}

.topbar {
  position: fixed;
  top: 0;
  right: 0;
  left: var(--sidebar-width);
  z-index: var(--topbar-zindex);
  display: flex;
  width: auto;
  min-width: 850px;
  height: var(--header-height);
  padding-right: 32px;
  padding-left: 32px;
  overflow: visible;
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  transition: all 0.3s linear;

  [dir='rtl'] & {
    right: var(--sidebar-width);
    left: 0;
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    position: relative;
    display: flex;
    flex-grow: 1;
    align-items: center;
    justify-content: space-between;
    height: 100%;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      height: 100%;
      padding: 0 8px;
      font-size: 18px;
      color: black;
      vertical-align: text-bottom;
    }

    .topbar__navigation {
      display: flex;
      flex-grow: 1;
      align-items: center;
      justify-content: flex-end;
      text-align: right;
    }

    .avatar-container {
      display: flex;
      align-items: center;
      margin-right: 10px;

      .avatar-wrapper {
        position: relative;
        margin-top: 15px;

        .user-avatar {
          width: 40px;
          height: 40px;
          cursor: pointer;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          position: absolute;
          top: 10px;
          right: -20px;
          display: none;
          font-size: 12px;
          cursor: pointer;
        }
      }
    }
  }

  .vertical-align-text-bottom {
    vertical-align: text-bottom;
  }
}

.topbar .topbar__search-result-title {
  margin: 10px 0 20px;
  font-size: 14px;
  font-weight: 500;
  line-height: 16.8px;
  color: #999;
}

.topbar__actions-popup {
  min-width: 225px;
  padding: 10px 0;
  border-radius: 12px;

  [dir='rtl'] & {
    margin-right: -80px;
    margin-left: initial;
  }
}

.topbar .topbar__empty-search {
  margin: 16px 0;
  text-align: center;

  svg {
    display: block;
    width: 25px;
    height: 25px;
    margin: 6px auto 10px;
  }

  div {
    font-size: 14px;
    font-weight: 400;
    color: #666;
    text-align: center;
  }
}

.topbar .topbar__empty-search--result {
  text-align: left;

  div {
    text-align: left;
  }
}

.topbar__actions-popup ::v-deep .topbar__divider {
  width: 100%;
  height: 1px;
  margin: 6px 24px 6px;
  background: #f2f2f2;
}

.topbar__actions-popup .el-dropdown-menu__item {
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 12px 24px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #000;

  &:hover,
  &:focus,
  &:active {
    color: #000;
    background-color: #f2f2f2;
  }
}

.topbar__actions-popup .el-dropdown-menu__item > * {
  display: flex;
  align-items: center;

  /* width: 100%; */
}

.topbar__actions-popup .el-dropdown-menu__item svg {
  width: 20px;
  height: 20px;
}

.el-dropdown-menu__item.topbar__actions-item--delete {
  color: #e02d48;
  border-bottom: none;

  &:hover,
  &:focus,
  &:active {
    color: #e02d48;
  }
}

.el-dropdown-menu__item.topbar__actions-item-dropdown {
  padding: 0 24px !important;
}

.el-dropdown-menu__item.topbar__actions-item ::v-deep .topbar__language {
  margin-bottom: 1px;
  margin-left: 5px;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  color: $text-secondary-color;
}

.el-dropdown-menu__item.topbar__actions-item ::v-deep .topbar_collapse--title {
  display: flex;
  align-items: center;
}

.el-dropdown-menu__item.topbar__actions-item
  .el-collapse
  ::v-deep
  .topbar__language {
  margin-bottom: 1px;
  margin-left: 5px;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  color: $text-secondary-color;
}

.el-dropdown-menu__item.topbar__actions-item--header {
  display: block;
  gap: 0;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
}

.el-dropdown-menu__item.topbar__actions-item--header div {
  margin-bottom: 5px;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: $text-secondary-color;
}

.topbar__notifications {
  display: flex;
}

.topbar__notifications-icon {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  cursor: pointer;

  svg {
    width: 25px;
    height: 25px;
  }
}

.topbar__notifications-icon.topbar__notifications-icon--active {
  background-color: rgba(60, 60, 60, 0.7);
  border-radius: 10px;
}

.topbar__notifications-number {
  position: absolute;
  top: 7px;
  left: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 9px;
  height: 9px;
  font-size: 9px;
  font-weight: 500;
  color: #fff;
  background-color: #e02d48;
  border-radius: 100%;
}
</style>

<style lang="scss">
$text-secondary-color: #999;
.topbar__notifications-dropdown {
  min-width: 352px;
  max-width: 352px;
  border-radius: 14px;
  box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.15);
}

.topbar__notifications-dropdown .el-dropdown-menu__item {
  padding: 0;
}

.topbar__notifications-dropdown .el-dropdown-menu__item:first-child {
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}

.topbar__notifications-item {
  padding: 17px 24px 17px;
}

.topbar__notifications-item.topbar__notifications-item--empty {
  display: flex;
  flex-direction: column;
  align-content: center;

  svg {
    width: 64px;
    height: 64px;
    margin: 0 auto;
  }

  > div {
    margin-bottom: 10px;
  }

  > div:nth-child(2) {
    margin-top: 14px;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    color: #000;
    text-align: center;
  }

  > div:nth-child(3) {
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    text-align: center;
  }
}

.topbar__notifications-item-divider {
  height: 1px;
  background-color: #f2f2f2;
}

.topbar__notifications-item-divider-search {
  height: 1px;
  margin: 20px 0 25px;
  background-color: #f2f2f2;
}

.topbar__notifications-item-title {
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  color: #000;
  cursor: pointer;
}

.topbar__notifications-item-time {
  margin-top: 14px;
  font-size: 12px;
  font-weight: 400;
  line-height: 26px;
}

.topbar__notifications-item-respond {
  width: fit-content;
  margin-top: 5px;
  font-size: 12px;
  font-weight: 400;
  line-height: 22px;
  text-decoration-line: underline;

  &:hover {
    color: #666;
  }
}

.topbar__notifications-see-all {
  width: fit-content;
  margin: 14px 24px 14px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: $text-secondary-color;
  text-decoration-line: underline;
  cursor: pointer;

  &:hover {
    background-color: #fff !important;
  }
}
</style>
